import type {
  PSPegawaiProfile,
  KinerjaPsPegawaiRoleType,
} from 'types/kinerja-ps-pegawai'

/**
 * Checks if a user has a specific role.
 * @param data - The user's profile data.
 * @param role - The role to check.
 * @returns Returns true if the user has the specified role, otherwise false.
 */
export const isUserHasRole = (
  data: PSPegawaiProfile,
  role: KinerjaPsPegawaiRoleType
) => {
  if (!data) return false

  return (
    data?.roles?.some((item: KinerjaPsPegawaiRoleType) => {
      return item === role
    }) || false
  )
}

/**
 * Checks if the user has the PS role.
 * @param data - The PSPegawaiProfile data.
 * @returns A boolean indicating whether the user has the PS role.
 */
export const isUserPegawaiPengawasSekolah = (data: PSPegawaiProfile) => {
  return isUserHasRole(data, 'PS')
}

/**
 * Checks if the user has the Tim Kinerja role.
 * @param data - The PSPegawaiProfile data.
 * @returns A boolean indicating whether the user has the DINAS role.
 */
export const isUserTimKinerjaPengawasSekolah = (data: PSPegawaiProfile) => {
  return isUserHasRole(data, 'TK')
}

/**
 * Checks if the user has the Pejabat Penilai Kinerja role.
 * @param data - The PSPegawaiProfile data.
 * @returns A boolean indicating whether the user has the DINAS role.
 */
export const isUserPPKPengawasSekolah = (data: PSPegawaiProfile) => {
  return isUserHasRole(data, 'PPK')
}
